import { z } from 'zod';

import { eventDetailSchema } from './events.js';

export const APPLICATION_NOTE_MAX = 200;
/** PRIVACY §4: at most this many pending applications per user. */
export const MAX_PENDING_APPLICATIONS = 10;

/** `POST /v1/events/:id/applications`. The optional note replaces DMs before acceptance. */
export const applyRequestSchema = z.strictObject({
	message: z
		.string()
		.trim()
		.max(APPLICATION_NOTE_MAX)
		.nullish()
		.transform((value) => (value === undefined || value === null || value === '' ? null : value)),
});

/** The new status and the event as the applicant now sees it (accepted → participant view). */
export const applyResponseSchema = z.object({
	status: z.enum(['pending', 'accepted']),
	event: eventDetailSchema,
});

export const applicationIdParamsSchema = z.object({ id: z.uuid() });

/**
 * `DELETE /v1/applications/:id`: withdraw a pending application or leave an accepted one.
 * `event` is null if the viewer can no longer see it.
 */
export const withdrawResponseSchema = z.object({ event: eventDetailSchema.nullable() });

/** `POST /v1/me/bot-access` (D24): the result of Telegram's `requestWriteAccess()`. */
export const botAccessRequestSchema = z.strictObject({ granted: z.boolean() });

export type WithdrawResponse = z.infer<typeof withdrawResponseSchema>;
export type ApplyRequest = z.input<typeof applyRequestSchema>;
export type ApplyResponse = z.infer<typeof applyResponseSchema>;
